import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@movilidad/app-core';
import { User } from '@shared/models';

import { getRedirectPath, MOVILIDAD_SESSION, needsBirthdayCapture } from './session.config';

// `authGuard` y `guestGuard` viven en @movilidad/app-core desde TEC-293 (con las rutas de
// `MOVILIDAD_SESSION`, que `main.ts` entrega con `provideMovilidadSession()`). Aquí queda el
// guard propio de Movilidad.

/** La pantalla de fecha de nacimiento: sólo para quien la tiene pendiente. */
export const captureBirthdayGuard: CanActivateFn = async () => {
  const session = inject(SessionService);
  const router = inject(Router);

  const authenticated = await session.isAuthenticated();
  if (!authenticated) {
    return router.createUrlTree([MOVILIDAD_SESSION.routes.signedOut]);
  }

  const user = (await session.getStoredUser<User>()) || null;
  if (!needsBirthdayCapture(user)) {
    return router.createUrlTree([getRedirectPath(user)]);
  }
  return true;
};
